import React from 'react';
import styled from 'styled-components';
import { Box, Divider } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { DetailBox } from 'common/components/DetailBox';
import { DetailRow } from 'common/components/DetailRow';
import { useCompanyQuery } from 'graphql/types';
import { useSnackbarContext } from 'common/context';
import { Link } from 'common/components/Link';

interface IProps {
    className?: string;
}

export const BaseBudgetDetailBox = ({ className }: IProps) => {
    const { t } = useTranslation();
    const { setSnackbarState } = useSnackbarContext();
    const { data, loading, error } = useCompanyQuery({
        onError: (error) => {
            setSnackbarState({
                message: error.message,
                variant: 'error',
            });
        },
    });
    const { company } = data || {};

    return (
        <DetailBox
            className={className}
            error={!!error}
            id="budget"
            loading={loading}
            title={t('company.budgetHeader')}
        >
            {company?.budgets.map((budget) => (
                <Box key={budget.id}>
                    <DetailRow bold description={t('company.budget')}>
                        {budget.name}
                        <Box component="span" display="block" mt={2}>
                            {budget.description}
                        </Box>
                    </DetailRow>
                    {budget.infoUrl && (
                        <DetailRow
                            bold
                            description={t('company.informationPage')}
                        >
                            <Link href={budget.infoUrl} target="_blank" to="">
                                {t('company.downloadPdf')}
                            </Link>
                        </DetailRow>
                    )}
                    <Divider className="divider" />
                </Box>
            ))}
        </DetailBox>
    );
};

export const BudgetDetailBox = styled(BaseBudgetDetailBox)`
    .divider {
        margin: ${({ theme }) => `${theme.spacing(5)}px 0`};
    }

    ${Link} {
        text-decoration: underline;
    }

    ${DetailRow} + ${DetailRow} {
        margin-top: ${({ theme }) => `${theme.spacing(5)}px`};
    }
`;
